import { render, staticRenderFns } from "./VideoEditTab.vue?vue&type=template&id=49ed7f90&"
import script from "./VideoEditTab.vue?vue&type=script&lang=js&"
export * from "./VideoEditTab.vue?vue&type=script&lang=js&"
import style0 from "./VideoEditTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports